<template>
    <div id="notifications-template">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Partner', to: { path: '/partnership-member' } },
                { text: 'Tambah Partner' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Tambah Partner</h3>

        <v-card flat>
            <v-stepper v-model="step" flat class="pa-0" color="blew">
                <v-card-text>
                    <v-row
                        no-gutters
                        style="box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.05)"
                    >
                        <v-col cols="7">
                            <v-stepper-header flat style="box-shadow: none">
                                <v-stepper-step :complete="step > 1" step="1">
                                    Profile Partner
                                </v-stepper-step>

                                <v-divider></v-divider>

                                <v-stepper-step :complete="step > 2" step="2">
                                    Profile Penanggung Jawab
                                </v-stepper-step>
                                <v-divider></v-divider>

                                <v-stepper-step step="3">
                                    Preview
                                </v-stepper-step>
                            </v-stepper-header>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-stepper-items>
                    <v-stepper-content step="1">
                        <template>
                            <div class="mb-2">
                                <v-list-item two-line class="pa-0">
                                    <v-list-item-content class="pa-0">
                                        <v-list-item-title
                                            class="font-weight-bold pb-2"
                                        >
                                            Nama Partner *
                                        </v-list-item-title>

                                        <v-text-field
                                            placeholder="Nama Partner"
                                            v-model="form.nama"
                                            outlined
                                        />
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item two-line class="pa-0">
                                    <v-list-item-content class="pa-0">
                                        <v-list-item-title
                                            class="font-weight-bold pb-2"
                                        >
                                            Provinsi *
                                        </v-list-item-title>

                                        <v-autocomplete
                                            placeholder="Pilih Provinsi"
                                            outlined
                                            class="pa-0"
                                            v-model="form.provinsi"
                                            :items="data_provinsi"
                                            item-text="nama_provinsi"
                                            item-value="kode_provinsi"
                                            v-on:change="getDataCity()"
                                        ></v-autocomplete>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item two-line class="pa-0">
                                    <v-list-item-content class="pa-0">
                                        <v-list-item-title
                                            class="font-weight-bold pb-2"
                                        >
                                            Kota/Kabupaten *
                                        </v-list-item-title>

                                        <v-autocomplete
                                            placeholder="Pilih Provinsi"
                                            outlined
                                            class="pa-0"
                                            v-model="form.kota"
                                            :items="data_kab_kota"
                                            item-text="nama_kabupaten_kota"
                                            item-value="kode_kabupaten_kota"
                                            v-on:change="getDataDistrict()"
                                        ></v-autocomplete>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item two-line class="pa-0">
                                    <v-list-item-content class="pa-0">
                                        <v-list-item-title
                                            class="font-weight-bold pb-2"
                                        >
                                            Kecamatan *
                                        </v-list-item-title>

                                        <v-autocomplete
                                            placeholder="Pilih Provinsi"
                                            outlined
                                            class="pa-0"
                                            v-model="form.kecamatan"
                                            :items="data_kecamatan"
                                            item-text="nama_kecamatan"
                                            item-value="kode_kecamatan"
                                            v-on:change="getDataSubdistrict()"
                                        ></v-autocomplete>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item two-line class="pa-0">
                                    <v-list-item-content class="pa-0">
                                        <v-list-item-title
                                            class="font-weight-bold pb-2"
                                        >
                                            Kelurahan *
                                        </v-list-item-title>

                                        <v-autocomplete
                                            placeholder="Pilih Kelurahan"
                                            outlined
                                            class="pa-0"
                                            v-model="form.kelurahan"
                                            :items="data_kelurahan"
                                            item-text="nama_kelurahan_desa"
                                            item-value="kode_kelurahan_desa"
                                        ></v-autocomplete>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item two-line class="pa-0">
                                    <v-list-item-content class="pa-0">
                                        <v-list-item-title
                                            class="font-weight-bold pb-2"
                                        >
                                            Alamat Lengkap *
                                        </v-list-item-title>

                                        <v-text-field
                                            placeholder="Alamat Lengkap"
                                            v-model="form.alamat"
                                            outlined
                                        />
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item two-line class="pa-0">
                                    <v-list-item-content class="pa-0">
                                        <v-list-item-title
                                            class="font-weight-bold pb-2"
                                        >
                                            Deskripsi *
                                        </v-list-item-title>

                                        <v-text-field
                                            placeholder="Alamat Lengkap"
                                            v-model="form.deskripsi"
                                            outlined
                                        />
                                    </v-list-item-content>
                                </v-list-item>
                            </div>
                            <v-row class="pa-4">
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    @click="$router.go(-1)"
                                    class="mr-2"
                                >
                                    Batal
                                </v-btn>
                                <v-btn
                                    color="primary"
                                    depressed
                                    @click="goToNextStep()"
                                >
                                    Selanjutnya
                                </v-btn>
                            </v-row>
                        </template>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                        <template>
                            <!-- <div class="mb-2">
                <v-list-item two-line class="pa-0">
                  <v-list-item-content class="pa-0">
                    <v-list-item-title
                      class="font-weight-bold pb-2 mb-6"
                      style="font-size: 18px"
                    >
                      Penanggung Jawab 1
                    </v-list-item-title>

                    <v-list-item-title class="font-weight-bold pb-2">
                      Nama Penanggung Jawab
                    </v-list-item-title>

                    <v-text-field
                      placeholder="Nama Penanggung Jawab"
                      v-model="form.data_pic[0].nama"
                      outlined
                    />
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line class="pa-0">
                  <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                      Nomor Telepon
                    </v-list-item-title>

                    <v-text-field
                      placeholder="08XXXXXXXXX"
                      v-model="form.data_pic[0].noTelp"
                      outlined
                    />
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line class="pa-0">
                  <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                      Email
                    </v-list-item-title>

                    <v-text-field
                      placeholder="email@contoh.com"
                      v-model="form.data_pic[0].email"
                      outlined
                    />
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line class="pa-0">
                  <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                      Jabatan
                    </v-list-item-title>

                    <v-text-field
                      placeholder="Jabatan Pekerjaan"
                      v-model="form.data_pic[0].jabatan"
                      outlined
                    />
                  </v-list-item-content>
                </v-list-item>
              </div> -->

                            <!-- <div class="mb-2">
                <v-list-item two-line class="pa-0">
                  <v-list-item-content class="pa-0">
                    <v-list-item-title
                      class="font-weight-bold pb-2 mt-2 mb-6"
                      style="font-size: 18px"
                    >
                      Penanggung Jawab 2
                    </v-list-item-title>

                    <v-list-item-title class="font-weight-bold pb-2">
                      Nama Penanggung Jawab
                    </v-list-item-title>

                    <v-text-field
                      placeholder="Nama Penanggung Jawab"
                      v-model="form.data_pic[1].nama"
                      outlined
                    />
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line class="pa-0">
                  <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                      Nomor Telepon
                    </v-list-item-title>

                    <v-text-field
                      placeholder="08XXXXXXXXX"
                      v-model="form.data_pic[1].noTelp"
                      outlined
                    />
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line class="pa-0">
                  <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                      Email
                    </v-list-item-title>

                    <v-text-field
                      placeholder="email@contoh.com"
                      v-model="form.data_pic[1].email"
                      outlined
                    />
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line class="pa-0">
                  <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                      Jabatan
                    </v-list-item-title>

                    <v-text-field
                      placeholder="Jabatan Pekerjaan"
                      v-model="form.data_pic[1].jabatan"
                      outlined
                    />
                  </v-list-item-content>
                </v-list-item>
              </div> -->

                            <v-row class="pa-4">
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    @click="goToPrevStep()"
                                    class="mr-2"
                                >
                                    Kembali
                                </v-btn>
                                <v-btn
                                    color="primary"
                                    depressed
                                    @click="goToNextStep()"
                                >
                                    Selanjutnya
                                </v-btn>
                            </v-row>
                        </template>
                    </v-stepper-content>

                    <v-stepper-content step="3">
                        <div>
                            <div>
                                <h4 class="font-weight-bold mb-4 ml-4">
                                    Profil Sekolah
                                </h4>
                            </div>
                            <v-simple-table>
                                <template v-slot:default>
                                    <tbody>
                                        <tr>
                                            <td width="20%">Nama Partner</td>
                                            <td>
                                                {{ form.nama }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Provinsi</td>
                                            <td>
                                                {{ nama_provinsi }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Kota/Kabupaten</td>
                                            <td>
                                                {{ nama_kota }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Kecamatan</td>
                                            <td>
                                                {{ nama_kecamatan }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Kelurahan</td>
                                            <td>
                                                {{ nama_kelurahan }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Alamat Lengkap Sekolah</td>
                                            <td>
                                                {{ form.alamat }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Nomor Telepon</td>
                                            <td>
                                                {{ form.no_telp }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>

                        <div class="mt-10">
                            <div>
                                <h4 class="font-weight-bold mb-4 ml-4">
                                    Penanggung Jawab
                                </h4>
                            </div>
                            <!-- <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td width="20%">Nama Penanggung Jawab 1</td>
                      <td>
                        {{ form.data_pic[0].nama }}
                      </td>
                    </tr>
                    <tr>
                      <td>Nomor Telepon</td>
                      <td>
                        {{ form.data_pic[0].noTelp }}
                      </td>
                    </tr>
                    <tr>
                      <td>Email</td>
                      <td>
                        {{ form.data_pic[0].email }}
                      </td>
                    </tr>
                    <tr>
                      <td>Jabatan</td>
                      <td>
                        {{ form.data_pic[0].jabatan }}
                      </td>
                    </tr>
                    <tr>
                      <td width="20%">Nama Penanggung Jawab 2</td>
                      <td>
                        {{ form.data_pic[1].nama }}
                      </td>
                    </tr>
                    <tr>
                      <td>Nomor Telepon</td>
                      <td>
                        {{ form.data_pic[1].noTelp }}
                      </td>
                    </tr>
                    <tr>
                      <td>Email</td>
                      <td>
                        {{ form.data_pic[1].email }}
                      </td>
                    </tr>
                    <tr>
                      <td>Jabatan</td>
                      <td>
                        {{ form.data_pic[1].jabatan }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table> -->
                        </div>
                        <v-row class="pa-4">
                            <v-spacer></v-spacer>
                            <v-btn text @click="goToPrevStep()" class="mr-2">
                                Kembali
                            </v-btn>
                            <v-btn
                                color="primary"
                                depressed
                                @click="submitActivationCode()"
                            >
                                Simpan
                            </v-btn>
                        </v-row>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import _ from "lodash";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import axios from "axios";

export default {
    name: "notifications-template",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            token: JSON.parse(localStorage.getItem("token")).value,
            isLoading: false,
            data: [],
            form: {
                nama: null,
                alamat: null,
                negara: null,
                provinsi: null,
                kota: null,
                kecamatan: null,
                kelurahan: null,
                nama_kepsek: null,
                npsn: null,
                no_telp: null,
                pic_data: [],
            },
            page: "form",
            step: 1,
            stepName: [
                "Profile Partner",
                "Profile Penanggung Jawab",
                "Preview",
            ],
            data_provinsi: null,
            data_kab_kota: null,
            data_kecamatan: null,
            data_kelurahan: null,
            nama_provinsi: null,
            nama_kota: null,
            nama_kecamatan: null,
            nama_kelurahan: null,
        };
    },

    watch: {},

    mounted() {
        this.getDataProvince();

        if (this.$route.query.id) {
            this.fetchData();
            this.getDataCity();
            this.getDataDistrict();
            this.getDataSubdistrict();
        }
    },

    methods: {
        fetchData() {
            const context = this;
            const id = this.$route.query.id;
            const url = `${process.env.API_BASE_URL}partnership/admin/partner/detail/${id}`;

            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    var data = response.data;
                    context.form = data;

                    context.form.provinsi = data.partner_provinsi.kode_provinsi;
                    context.form.kota =
                        data.partner_kabupaten_kota.kode_kabupaten_kota;
                    context.form.kecamatan =
                        data.partner_kecamatan.kode_kecamatan;
                    context.form.kelurahan =
                        data.partner_kelurahan.kode_kelurahan_desa;

                    context.nama_provinsi = data.partner_provinsi.nama_provinsi;
                    context.nama_kota =
                        data.partner_kabupaten_kota.kode_kabupaten_kota;
                    context.nama_kecamatan =
                        data.partner_kecamatan.nama_kecamatan;
                    context.nama_kelurahan =
                        data.partner_kelurahan.nama_kelurahan_desa;

                    context.getDataCity();
                    context.getDataDistrict();
                    context.getDataSubdistrict();
                }
            });
        },
        getDataProvince() {
            const context = this;
            const url = `${process.env.API_BASE_URL}partnership/region/list-provinsi`;

            const authToken = this.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.data_provinsi = response.data;
                }
            });
        },
        getDataCity() {
            const context = this;
            const url = `${process.env.API_BASE_URL}partnership/region/list-kabkota?kode_provinsi=${this.form.provinsi}`;

            const authToken = this.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.data_kab_kota = response.data;
                    context.data_kecamatan = [];
                    context.data_kelurahan = [];
                }
            });
        },
        getDataDistrict() {
            const context = this;
            const url = `${process.env.API_BASE_URL}partnership/region/list-kecamatan?kode_kabkota=${this.form.kota}`;

            const authToken = this.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.data_kecamatan = response.data;
                    context.data_kelurahan = [];
                }
            });
        },
        getDataSubdistrict() {
            const context = this;
            const url = `${process.env.API_BASE_URL}partnership/region/list-kelurahan?kode_kecamatan=${this.form.kecamatan}`;

            const authToken = this.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.data_kelurahan = response.data;
                }
            });
        },
        goToPrevStep: function () {
            this.step--;
        },
        goToNextStep: function () {
            this.step++;
        },
        submitActivationCode() {
            this.$router.push("/partnership-member");
        },
    },
};
</script>



// WEBPACK FOOTER //
// PartnershipMemberForm.vue?200f1f48